<!--
 * @Description: 
 * @Author: pcc
 * @Date: 2022-11-02 17:20:32
 * @LastEditors: zml
 * @LastEditTime: 2026-04-22 15:56:29
-->
<template>
  <div class="page">
    <div class="container">
      <div style="margin: 23px 0;font-size: 24px;">{{ $t("Orders") }}</div>
      <div class="order-list" v-if="orderList.length>0">
        <div
          class="order-boxList"
          v-for="(orderInfo, index) in orderList"
          :key="index"
          @click="$router.push({ path: '/order/detail', query: { orderNo: orderInfo.orderNo } })"
        >
          <div class="orderNumber">
            {{ $t('number') }}：
            {{ orderInfo.orderNo }}
          </div>
          <div class="orderTime">
            <span class="lable">{{ $t('orderTime') }}：</span>
            {{ orderInfo.createdTime }}
          </div>
          <div class="orderTime">
            <span class="lable">{{ $t('linkman') }}：</span>
            {{ orderInfo.consignee }}
          </div>
          <div class="orderTime">
            <span class="lable">{{ $t('email') }}：</span>
            {{ orderInfo.createdUserEmail }}
          </div>
        </div>
        <!-- <order-box v-for="(item, index) in orderList" :orderInfo="item" :key="index"></order-box> -->
      </div>
      <el-empty :description="$t('noData')" v-else></el-empty>
    </div>
    <div class="pagination">
      <el-pagination
        background="red"
        :current-page="queryParam.pageNo"
        :page-size="queryParam.pageSize"
        :page-sizes="[10, 20, 30, 40]"
        :total="totalRows"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { getOrderList } from '@/api/order'
import { mapGetters } from 'vuex'
import orderBox from '@/components/public/order/orderBox'
export default {
  name: 'pageOrder',
  components: {
    orderBox
  },
  data() {
    return {
      orderList: [],
      queryParam: {
        pageNo: 1,
        pageSize: 15,
        sortField: '',
        sortOrder: '',
        keywords: '',
        status: -1
      },
      totalRows: 0
    }
  },
  computed: {
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    })
  },
  created() {
    this.initData()
  },
  methods: {
    // 初始化
    initData() {
      this.queryParam.userAccount = this.userInfo.userAccount
      getOrderList(this.queryParam).then(res => {
        this.orderList = res.data.rows
        this.totalRows = res.data.totalRows
      })
    },
    // 选择页码大小
    handleSizeChange(pageSize) {
      this.queryParam.pageSize = pageSize
      this.initData()
    },
    // 分页
    handleCurrentChange(pageNo) {
      this.queryParam.pageNo = pageNo
      this.initData()
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  min-height: calc(100vh - 271px);
  background: linear-gradient(135deg, #aee7fb, #fadbea 51%, #f9e1cf);
  width: 100%;
  padding: 10px 0;
}

.order-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
.order-boxList {
  width: 420px;
  height: 144px;
  opacity: 0.6;
  background: #ffffff;
  border-radius: 12px;
  padding-top: 30px;
  padding-left: 20px;
  margin-bottom: 30px;
  margin-right: 30px;
  cursor: pointer;
  .orderNumber {
    font-size: 20px;
    font-weight: 500;
    color: #222222;
  }
  .orderTime {
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #595959;
    margin-top: 5px;
  }
}

.pagination {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin-top: 15px;
}

::v-deep .el-pager li {
  margin: 0 5px !important;
}
::v-deep .el-pagination .btn-next {
  margin: 0 5px !important;
}
::v-deep .el-pagination .btn-prev {
  margin: 0 5px !important;
}
</style>